import React, { FunctionComponent, ReactNode } from 'react';

export interface IExternalLinkProps {
  children?: string | ReactNode;
  url: string;
  blank?: boolean;
  className?: string;
}

export const ExternalLink: FunctionComponent<IExternalLinkProps> = props => {
  const { children, url, className, blank } = props;

  return (
    <a
      href={url}
      className={className}
      target={blank ? '_blank' : ''}
      rel="noreferrer"
    >
      {children}
    </a>
  );
};
